module.exports = __webpack_public_path__ + "img/box-bg1.90fc618e.png";